import React from 'react';
import { cn } from 'utils';
import { useTimeline } from './TimelineProvider';

/**
 * The marker that positions wherever the user has selected in the timeline.
 */
export function TimelinePositionMarker(): React.ReactElement {
  const { markerPosition } = useTimeline();

  return (
    <div
      className={cn([
        'odin-flex',
        'odin-flex-col',
        'odin-items-center',
        'odin-justify-center',
        'odin-absolute',
        'odin-top-0',
        'odin-bottom-0',
        'odin-z-100',
      ])}
      style={{
        left: `${markerPosition * 100}%`,
        transform: 'translateX(-50%)',
      }}
    >
      <div
        aria-hidden="true"
        className={cn([
          'odin-border',
          'odin-border-[8px]',
          'odin-border-odin-black',
          'odin-border-b-transparent',
          'odin-border-l-transparent',
          'odin-border-r-transparent',
          'odin-h-0',
          'odin-w-0',
          'odin-mb-[-10px]', // Adjust for the top arrow to overlap
        ])}
      />
      <div
        aria-hidden="true"
        className={cn([
          'odin-border',
          'odin-border-1',
          'odin-border-odin-black',
          'odin-relative',
          'odin-w-0',
          'odin-flex-1',
        ])}
      />
      <div
        aria-hidden="true"
        className={cn([
          'odin-border',
          'odin-border-[8px]',
          'odin-border-odin-black',
          'odin-border-l-transparent',
          'odin-border-r-transparent',
          'odin-border-t-transparent',
          'odin-h-0',
          'odin-w-0',
          'odin-mt-[-10px]', // Adjust for the bottom arrow to overlap
        ])}
      />
    </div>
  );
}
